import { Button, PageHeader } from '@/components';
import { PollsList } from '@/features/polls/PollsList';

import { useAuth } from '@/features/auth/AuthProvider';
import { useNavigate } from '@solidjs/router';
import { Show } from 'solid-js';

export default function Polls() {
  const { session } = useAuth();
  const navigate = useNavigate();
  return (
    <section>
      <PageHeader
        title="Polls"
        actions={
          <Show when={session()?.permissions.has('polls:create')}>
            <Button onClick={() => navigate('/polls/new')}>New Poll</Button>
          </Show>
        }
      />
      <div class="mx-auto max-w-6xl p-6">
        <PollsList />
      </div>
    </section>
  );
}
